import { AssetReference } from '@opallabs/cassini'
import { renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  centerTab?: string
}

export const MobileProfileHeader: React.FC<Props> = ({
  accountImage,
  accountName,
  centerTab = 'instagram-mobile-profile-igtv',
}) => (
  <div css={styles.headerWrapper}>
    <div css={styles.profile}>
      <ContentAvatar assetReference={accountImage} size={86} />
      <ul>
        <li>
          <span css={styles.boldText}>#</span>
          <br />
          Posts
        </li>
        <li>
          <span css={styles.boldText}>#</span>
          <br />
          Followers
        </li>
        <li>
          <span css={styles.boldText}>#</span>
          <br />
          Following
        </li>
      </ul>
    </div>
    <AccountName name={accountName} size={14} style={styles.account} />
    <div css={styles.buttonWrapper}>
      <ul>
        <li className={kuiperClassNames('igtv-blue-theme-btn')}>Follow</li>
        <li className={kuiperClassNames('igtv-light-theme-btn')}>Message</li>
        <li
          className={kuiperClassNames('igtv-light-theme-btn', 'igtv-icon-btn')}
        >
          {renderIcon('instagram-mobile-chevron', {
            height: 5,
            width: 8,
            ariaMode: 'hidden',
          })}
        </li>
      </ul>
    </div>
    <div css={styles.tabWrapper}>
      <ul>
        <li>
          {renderIcon('instagram-mobile-profile-posts', {
            height: 18,
            width: 18,
            ariaMode: 'hidden',
          })}
        </li>
        <li className={kuiperClassNames('active-tab')}>
          {renderIcon(centerTab, { height: 20, width: 18, ariaMode: 'hidden' })}
        </li>
        <li>
          {renderIcon('instagram-mobile-profile-tagged', {
            height: 18,
            width: 18,
            ariaMode: 'hidden',
          })}
        </li>
      </ul>
    </div>
  </div>
)
